import React, { useEffect } from "react";

const AdSense = () => {
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <div style={{ width: "100%", height: "100%", background: "white" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
        }}
        dangerouslySetInnerHTML={{
          __html: `
    <ins class="adsbygoogle"
         style="display:block;"
         data-ad-client="ca-pub-8160025106741040"
         data-ad-slot="4338288928"
         data-ad-format="auto"
         data-full-width-responsive="true"
         ></ins>
  `,
        }}
      />
    </div>
  );
};

export default AdSense;
